import { render, staticRenderFns } from "./HerosForm.vue?vue&type=template&id=a1c66acc&scoped=true"
import script from "./HerosForm.vue?vue&type=script&lang=js"
export * from "./HerosForm.vue?vue&type=script&lang=js"
import style0 from "./HerosForm.vue?vue&type=style&index=0&id=a1c66acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c66acc",
  null
  
)

export default component.exports